import React from 'react'
import Snackbar from '@mui/material/Snackbar'

const _duration = 3000

export const Context = React.createContext({
    createSnack: () => {},
    openSnack: () => {},
    deleteSnack: () => {}
})

export const Provider = ({...rest}) => {

    const [snackbars, setSnackbars] = React.useState({})
    const [controls, setControls] = React.useState({})


    const openSnack = (key) => {
        setControls({...controls, [key]: true})
    }
    const createSnack = (key, { message, duration = _duration, close, action }) => {
        setControls({...controls, key: false})
        setSnackbars({
            ...snackbars, 
            [key]: { message, duration, close, action }
        })
    }

    const deleteSnack = (key) => {
        const _controls = {...controls}
        delete _controls[key]
        
        const _snackbars = {...snackbars}
        delete _snackbars[key]

        setControls(_controls)
        setSnackbars(_snackbars)
    }

    return(
        <Context.Provider value={{
            createSnack,
            openSnack,
            deleteSnack
        }}>
            {rest.children}
            {Object.keys(snackbars).map((sk) => {
                console.log(snackbars[sk])
                return (
                <Snackbar 
                    open={controls[sk]} 
                    message={snackbars[sk].message} 
                    autoHideDuration={snackbars[sk].duration} 
                    onClose={(event, reason) => {
                        if (reason === 'clickaway') {
                            return;
                        }
                        setControls({...controls, [sk]: false})
                        snackbars[sk].close && snackbars[sk].close()
                    }}
                    action={() => {
                        snackbars[sk].action && snackbars[sk].action()
                    }}
                />
            )})}
        </Context.Provider>
    )
}